import { Model } from '@vuex-orm/core'


export default class QuestionOption extends Model {
    static get entity () {
        return 'questionOptions'
    }

    static fields () {
        return {
            id: this.uid(),
            questionId: this.uid(),
            text: this.string('').nullable(),
            type: this.string(''),
            imageUrl: this.string('').nullable(),
        }
    }
}
